export const CUSTOM_ENCODE_DELIMITER = "-_-_-";

export const customValueEncode = (s: string): string => {
  let out = "";

  for (let i = 0; i < s.length; i++) {
    const charCode = s.charCodeAt(i);
    if (
      (charCode < 48 || charCode > 57) && // 0 - 9
      (charCode < 65 || charCode > 90) && // A - Z
      (charCode < 97 || charCode > 122) && // a - z
      charCode !== 45 && // -
      charCode !== 95 // _
    ) {
      out += `${CUSTOM_ENCODE_DELIMITER}${charCode
        .toString(16)
        .padStart(2, "0")}`;
    } else {
      out += s.at(i);
    }
  }

  return out;
};
